import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import userReducer from "../redux/user/userSlice";
import usersForPermissions from "../redux/user/usersForPermissionsSlice";
import userPermissionInsDel from "../redux/user/userPermissionInsDelSlice";
import usersQuery from "../redux/user/usersQuerySlice";
import usersPermissionsIns from "../redux/user/usersPermissionsInsSlice";
import userInviteReducer from "../redux/user/userInviteSlice";
import createInviteReducer from "../redux/user/createInviteSlice";

import schoolsReducer from "../redux/school/schoolsSlice";
import schoolReducer from "../redux/school/schoolSlice";
import schoolInsUpdReducer from "../redux/school/schoolInsUpdSlice";
import schoolClassroomsReducer from "../redux/school/schoolClassroomsSlice";
import schoolStudentsReducer from "../redux/school/schoolStudentsSlice";
import schoolDptosReducer from "../redux/school/schoolDptosSlice";
import schoolRoutinesReducer from "../redux/school/schoolRoutinesSlice";

import classroomReducer from "../redux/classroom/classroomSlice";
import classroomInsUpdReducer from "../redux/classroom/classroomInsUpdSlice";
import classroomStudentsReducer from "../redux/classroom/classroomStudentsSlice";
import classroomAddStudentReducer from "../redux/classroom/classroomStudentAddSlice";
import classroomRemoveStudentReducer from "../redux/classroom/classroomRemoveStudentSlice";
import classroomStudentInvitesReducer from "../redux/classroom/classroomStudentInvitesSlice";

import studentClassroomsReducer from "../redux/student/studentClassroomsSlice";
import studentReducer from "../redux/student/studentSlice";
import studentInsUpdReducer from "../redux/student/studentInsUpdSlice";
import studentSchoolsReducer from "../redux/student/studentSchoolsSlice";
import studentInviteReducer from "../redux/student/getStudentInviteSlice";

import dptoReducer from "../redux/dpto/dptoSlice";
import dptoInsUpdReducer from "../redux/dpto/dptoInsUpdSlice";

import routineReducer from "../redux/routine/routineSlice";
import routineInsUpdReducer from "../redux/routine/routineInsUpdSlice";
import routineItemListReducer from "../redux/routine/routineItemListSlice";
import routineItemReducer from "../redux/routine/routineItemSlice";
import routineItemInsUpdReducer from "../redux/routine/routineItemInsUpdSlice";
import routineItemOptionReducer from "../redux/routine/routineItemOptionSlice";
import routineItemOptionInsUpdReducer from "../redux/routine/routineItemOptionInsUpdSlice";
import routineItemOptionListReducer from "../redux/routine/routineItemOptionListSlice";
// import routineRecordReducer from "../redux/routine/routineRecordSlice";
import routineRecordListReducer from "../redux/routine/routineRecordListSlice";
import routineRecordChangeReducer from "../redux/routine/routineRecordChangeSlice";
import routineCommentChangeReducer from "../redux/routine/routineCommentChangeSlice";
import routineCommentListReducer from "../redux/routine/routineCommentListSlice";

import imageReducer from "../redux/image/imageSlice";
import imageInsReducer from "../redux/image/imageInsSlice";
import imagesUploadReducer from "../redux/image/imagesUploadSlice";
import imagesReducer from "../redux/image/imagesSlice";
import imageSetAvatarReducer from "../redux/image/imageSetAvatar";
import imageReviewReducer from "../redux/image/imageReviewSlice";

import fileInsReducer from "../redux/file/fileInsSlice";
import filesUploadReducer from "../redux/file/filesUploadSlice";

import faceDetailsListReducer from "../redux/face/faceDetailsListSlice";
import faceSetNobodyReducer from "../redux/face/faceSetNobodySlice";
import faceSetSomebodyReducer from "../redux/face/faceSetSomebodySlice";
import faceQueryReducer from "../redux/face/faceQuerySlice";

import suggestionDetailsListReducer from "../redux/face/suggestion/suggestionDetailsListSlice";

import conversationListReducer from "../redux/conversation/conversationListSlice";
import conversationCreateReducer from "../redux/conversation/conversationCreateSlice";
import conversationUpdReadReducer from "../redux/conversation/conversationUpdReadSlice";
import conversationPartyUsersReducer from "../redux/conversation/conversationPartyUsersSlice";
import conversationUserReducer from "../redux/conversation/conversationUserSlice";
import messageListReducer from "../redux/conversation/messageListSlice";
import messageSendReducer from "../redux/conversation/messageSendSlice";
import messageSendMassiveReducer from "../redux/conversation/messageSendMassiveSlice";
import massiveMessageReducer from "../redux/conversation/massive/massiveMessageSlice";
import massiveMessageUserReducer from "../redux/conversation/massive/massiveMessageUserSlice";
import messageDismissedReducer from "../redux/conversation/massive/messageDismissed";
import pureMessageReducer from "../redux/conversation/massive/pureMessageSlice";
import selectedConversationReducer from "../redux/navigation/selectedConversationSlice";

import objectCacheReducer from "../redux/object/objectCacheSlice";

import surveyReducer from "../redux/survey/surveySlice";
import surveyListReducer from "../redux/survey/surveyListSlice";
import surveyInsUpdReducer from "../redux/survey/surveyInsUpdSlice";
import surveyTargetReducer from "../redux/survey/surveyTargetSlice";
import surveyQuestionTargetListReducer from "../redux/survey/surveyTargetListSlice";
import surveyQuestionAnswerReducer from "../redux/survey/surveyQuestionAnswerSlice";
import surveyQuestionAnswerListReducer from "../redux/survey/surveyQuestionAnswerListSlice";
import surveyQuestionAnswerInsUpdReducer from "../redux/survey/surveyQuestionAnswerInsUpdSlice";

import homeworkReducer from "../redux/homework/homeworkSlice";
import homeworkClassroomListReducer from "../redux/homework/homeworkClassroomListSlice";
import homeworkInsUpdReducer from "../redux/homework/homeworkInsUpdSlice";
import homeworkReportReducer from "../redux/homework/homeworkReportSlice";
import homeworkCheckChangeReducer from "../redux/homework/homeworkCheckChangeSlice";
import homeworkCommentChangeReducer from "../redux/homework/homeworkCommentChangeSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    usersForPermissions: usersForPermissions,
    userPermissionInsDel: userPermissionInsDel,
    usersQuery: usersQuery,
    usersPermissionsIns: usersPermissionsIns,
    userInvite: userInviteReducer,
    createInvite: createInviteReducer,
    
    schools: schoolsReducer,
    school: schoolReducer,
    schoolInsUpd: schoolInsUpdReducer,
    schoolClassrooms: schoolClassroomsReducer,
    schoolStudents: schoolStudentsReducer,
    schoolDptos: schoolDptosReducer,
    schoolRoutines: schoolRoutinesReducer,

    classroom: classroomReducer,
    classroomInsUpd: classroomInsUpdReducer,
    classroomStudents: classroomStudentsReducer,
    classroomStudentAdd: classroomAddStudentReducer,
    classroomRemoveStudent: classroomRemoveStudentReducer,
    classroomStudentInvites: classroomStudentInvitesReducer,

    student: studentReducer,
    studentInsUpd: studentInsUpdReducer,
    studentClassrooms: studentClassroomsReducer,
    studentSchools: studentSchoolsReducer,
    studentInvite: studentInviteReducer,

    dpto: dptoReducer,
    dptoInsUpd: dptoInsUpdReducer,

    routine: routineReducer,
    routineInsUpd: routineInsUpdReducer,
    routineItem: routineItemReducer,
    routineItemList: routineItemListReducer,
    routineItemInsUpd: routineItemInsUpdReducer,
    routineItemOption: routineItemOptionReducer,
    routineItemOptionInsUpd: routineItemOptionInsUpdReducer,
    routineItemOptionList: routineItemOptionListReducer,
    // routineRecord: routineRecordReducer,
    routineRecordList: routineRecordListReducer,
    routineRecordChange: routineRecordChangeReducer,
    routineCommentChange: routineCommentChangeReducer,
    routineCommentList: routineCommentListReducer,

    image: imageReducer,
    imageSetAvatar: imageSetAvatarReducer,
    imageIns: imageInsReducer,
    imagesUpload: imagesUploadReducer,
    images: imagesReducer,
    imageReview: imageReviewReducer,

    fileIns: fileInsReducer,
    filesUpload: filesUploadReducer,

    faceDetailsList: faceDetailsListReducer,
    faceSetNobody: faceSetNobodyReducer,
    faceSetSomebody: faceSetSomebodyReducer,
    faceQuery: faceQueryReducer,

    suggestionDetailsList: suggestionDetailsListReducer,

    conversationList: conversationListReducer,
    conversationCreate: conversationCreateReducer,
    conversationUpdRead: conversationUpdReadReducer,
    conversationPartyUsers: conversationPartyUsersReducer,
    conversationUser: conversationUserReducer,
    messageList: messageListReducer,
    messageSend: messageSendReducer,
    messageSendMassive: messageSendMassiveReducer,
    massiveMessage: massiveMessageReducer,
    massiveMessageUser: massiveMessageUserReducer,
    messageDismissed: messageDismissedReducer,
    pureMessage: pureMessageReducer,
    selectedConversation: selectedConversationReducer,

    objectCache: objectCacheReducer,

    survey: surveyReducer,
    surveyList: surveyListReducer,
    surveyInsUpd: surveyInsUpdReducer,
    surveyTarget: surveyTargetReducer,
    surveyQuestionTargetList: surveyQuestionTargetListReducer,
    surveyQuestionAnswer: surveyQuestionAnswerReducer,
    surveyQuestionAnswerList: surveyQuestionAnswerListReducer,
    surveyQuestionAnswerInsUpd: surveyQuestionAnswerInsUpdReducer,

    homework: homeworkReducer,
    homeworkClassroomList: homeworkClassroomListReducer,
    homeworkInsUpd: homeworkInsUpdReducer,
    homeworkReport: homeworkReportReducer,
    homeworkCheckChange: homeworkCheckChangeReducer,
    homeworkCommentChange: homeworkCommentChangeReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
